export default "__VITE_ASSET__BALW6MUd__"